<template>
  <v-sheet outlined class="pa-4">
    <div class="controls">
      <label for="mySlider">Top Ranking Neighbors Number:</label>
      <input
          type="range"
          min="1"
          :max="maxAvailableN"
          v-model.number="topN"
      />

      <span id="sliderValue">{{ topN }}</span>
    </div>
    <div>
      <span>Run Batch Search using Sites in Current Network:   </span>
      <v-btn x-small color="primary" @click="submitSearch">Batch Search </v-btn>

    </div>

    <NetworkGraph
        :edges="edgesForChart"
        :nodes="nodesForChart"
    />
  </v-sheet>
</template>

<script>
import NetworkGraph from './NetworkGraph.vue'

export default {
  name: 'NetworkParent',
  components: { NetworkGraph },
  props: {
    result_data: { type: Object, required: true },
  },
  data() {
    return {
      topN: 15,
      // edgesForChart: [],
      // nodesForChart: []
    }
  },
  methods: {
    transform_for_highcharts(json_obj, top_n) {
      if (!json_obj?.n_info || !json_obj.edges) {
        return { edges: [], nodes: [] }
      }

      const keys = Object.keys(json_obj.n_info).map(Number).filter(Number.isFinite)
      if (keys.length === 0) return { edges: [], nodes: [] }

      const maxN = Math.max(...keys)
      top_n = Math.min(Math.max(1, top_n), maxN)

      const edge_count = json_obj.n_info[String(top_n)]
      if (!edge_count || edge_count <= 0) return { edges: [], nodes: [] }

      const edges = json_obj.edges.slice(0, edge_count).map(([u, v]) => [u, v])

      const degree = Object.create(null)
      const nodeSet = new Set()
      edges.forEach(([u, v]) => {
        degree[u] = (degree[u] || 0) + 1
        degree[v] = (degree[v] || 0) + 1
        nodeSet.add(u)
        nodeSet.add(v)
      })

      const scoreMap = new Map((json_obj.nodes || []).map(n => [n.name, n.score]))

      const nodesInEdges = Array.from(nodeSet)

      const degValues = nodesInEdges.map(id => degree[id] || 0)
      const dMin = Math.min(...degValues)
      const dMax = Math.max(...degValues)

      const rMin = 8, rMax = 34

      const scaleLog = (d) => {
        if (d <= 0) return rMin
        const logMin = Math.log1p(dMin || 1)
        const logMax = Math.log1p(dMax)
        const logVal = Math.log1p(d)
        return rMin + (rMax - rMin) * ((logVal - logMin) / (logMax - logMin))
      }
      const nodes = nodesInEdges.map(id => {
        const deg = degree[id] || 0
        const radius = scaleLog(deg) *0.5
        const score = Number(scoreMap.get(id) || 0)

        const parts = id.split('_')
        const label = parts.length >= 2 ? `${parts[0]}_${parts[1]}` : id

        return {
          id,
          name: label,
          score,
          degree: deg,
          marker: { radius }
        }
      })
      return { edges, nodes }
    },
    submitSearch() {
      const nodes = this.graphData.nodes
      if (!nodes.length) return


      const entries = this.nodesForChart.map(node => {
        return node.name.replace(/_/g, "\t");
      });

      const input = entries.join("\n");

      const formatted = entries.map(line => {
        const parts = line.split(/\s+/);
        return parts.length >= 2
            ? `${parts[0].toUpperCase()}_${parts[1].toUpperCase()}`
            : null;
      }).filter(Boolean);

      const query = {
        input: input,
        formatted: JSON.stringify(formatted),
      };

      return this.$router.push({ path: '/batch-search', query }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    }

  },
  computed: {
    graphData() {
      return this.transform_for_highcharts(this.result_data, this.topN)
    },
    edgesForChart() {
      return this.graphData.edges
    },
    nodesForChart() {
      return this.graphData.nodes
    },
    maxAvailableN() {
      if (!this.result_data?.n_info) return 1
      return Math.max(...Object.keys(this.result_data.n_info).map(Number))
    }
  }

}
</script>

<style scoped>
.controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 5px 0 5px;
}
</style>
